// extracted by mini-css-extract-plugin
module.exports = {"slideWrapper":"AW","imageWrapper":"AX","image":"AY","imageInCenter":"AZ","ctaWrapper":"A0","copyright":"A1","rentalBadge":"A2","sideGradient":"A3","bottomGradient":"A4"};